import type { InjectionKey } from "vue";
import type { IGroupModifiers, ISelectModifiers } from "#/types/iCardProduct";

export interface LiquidModifiersContext {
	localCounts: Record<string, number>;
	getAmount: (modifier: ISelectModifiers, group: IGroupModifiers) => number;
	getKey: (groupId: string, modId: string) => string;
	getModifierPrice: (modifier: ISelectModifiers) => number;
	selectModifier: (modifier: ISelectModifiers, group: IGroupModifiers) => Promise<boolean>;
	incrementModifier: (modifier: ISelectModifiers, group: IGroupModifiers) => Promise<boolean>;
	decrementModifier: (modifier: ISelectModifiers, group: IGroupModifiers) => void;
	removeModifier: (modifier: ISelectModifiers, group: IGroupModifiers) => void;
	canIncrementModifier: (modifier: ISelectModifiers, group: IGroupModifiers) => boolean;
	isSupportsModifierQuantity: (modifier: ISelectModifiers, group: IGroupModifiers) => boolean;
	shouldShowCounter: (modifier: ISelectModifiers, group: IGroupModifiers) => boolean;
	isHiddenModifier: (modifier: ISelectModifiers, group: IGroupModifiers) => boolean;
	isGroupSatisfied: (group: IGroupModifiers) => boolean;
}

export const liquidModifiersKey: InjectionKey<LiquidModifiersContext> = Symbol("liquidModifiers");
